import { PropsWithChildren } from 'react';

type UserAssetsCollectionListProps = {
  title: string;
};
export const UserAssetsCollectionList = ({
  title,
  children,
}: PropsWithChildren<UserAssetsCollectionListProps>) => {
  return (
    <div className="bg-surface-muted py-10">
      <div className="container">
        <h2 className="mb-8 text-lg">{title}</h2>
        <div className="flex flex-wrap">{children}</div>
      </div>
    </div>
  );
};
